import { z } from "zod";

export const createDateTimeRangeSchema = (required: boolean) => {
  return z
    .object({
      type: z.enum(["input", "variable"]),
      start: z.string().optional(),
      start_time: z.string().optional(),
      end: z.string().optional(),
      end_time: z.string().optional(),
      value: z.string().optional(),
      node_id: z.string().optional(),
      value_type: z.enum(["field", "object", ""]).optional(),
    })
    .superRefine((data, ctx) => {
      const hasStart = data.start && data.start.trim().length > 0;
      const hasStartTime = data.start_time && data.start_time.trim().length > 0;
      const hasEnd = data.end && data.end.trim().length > 0;
      const hasEndTime = data.end_time && data.end_time.trim().length > 0;
      const hasValue = data.value && data.value.trim().length > 0;

      if (data.type === "input") {
        if (required) {
          // If required, both start and start_time must be present
          if (!hasStart) {
            ctx.addIssue({
              code: "custom",
              message: "La fecha de inicio es obligatoria",
              path: ["start"],
            });
          }
          if (!hasStartTime) {
            ctx.addIssue({
              code: "custom",
              message: "La hora de inicio es obligatoria",
              path: ["start_time"],
            });
          }
        } else {
          // If not required but one is present, the other must be present too
          if (hasStart && !hasStartTime) {
            ctx.addIssue({
              code: "custom",
              message:
                "La hora de inicio es obligatoria cuando se proporciona fecha de inicio",
              path: ["start_time"],
            });
          }
          if (hasStartTime && !hasStart) {
            ctx.addIssue({
              code: "custom",
              message:
                "La fecha de inicio es obligatoria cuando se proporciona hora de inicio",
              path: ["start"],
            });
          }
        }
      }

      if (data.type === "variable") {
        if (required && !hasValue) {
          ctx.addIssue({
            code: "custom",
            message: "El valor es obligatorio",
            path: ["start"],
          });
        }
      }

      // Validate endType
      if (data.type === "input") {
        if (required) {
          // If required, both end and end_time must be present
          if (!hasEnd) {
            ctx.addIssue({
              code: "custom",
              message: "La fecha de fin es obligatoria",
              path: ["end"],
            });
          }
          if (!hasEndTime) {
            ctx.addIssue({
              code: "custom",
              message: "La hora de fin es obligatoria",
              path: ["end_time"],
            });
          }
        } else {
          // If not required but one is present, the other must be present too
          if (hasEnd && !hasEndTime) {
            ctx.addIssue({
              code: "custom",
              message:
                "La hora de fin es obligatoria cuando se proporciona fecha de fin",
              path: ["end_time"],
            });
          }
          if (hasEndTime && !hasEnd) {
            ctx.addIssue({
              code: "custom",
              message:
                "La fecha de fin es obligatoria cuando se proporciona hora de fin",
              path: ["end"],
            });
          }
        }
      }
    });
};

export const getDateTimeRangeDefaultValues = () => {
  return {
    type: "input",
    start: "",
    start_time: "",
    end: "",
    end_time: "",
    value: "",
    node_id: "",
    value_type: "field",
  };
};
